import { Modal } from '@dynamika-shared/ui/Modal/Modal';
import { FC } from 'react';

type ConfirmPositionModalProps = {
  onCancel: () => void;
  onOk: () => void;
  showModal: boolean;
};

export const ConfirmPositionModal: FC<ConfirmPositionModalProps> = ({
  onCancel,
  onOk,
  showModal,
}) => {
  return (
    <Modal
      zIndex={9999}
      width={440}
      onCancel={onCancel}
      onOk={onOk}
      okText='Confirm'
      open={showModal}
      title='Confirm visit position'
    >
      <span>
        Are you sure you want to confirm the position of the visit? This action
        cannot be undone
      </span>
    </Modal>
  );
};
